import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dhhp-card-subtitle',
  template: `<mat-card-subtitle>
  <ng-content></ng-content>
</mat-card-subtitle>`
})
export class DhhpCardSubtitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
